import { useInputState } from './useInputState';
import { vaildateMaxDigits } from '../maxDigits';
import { isNil } from '../boolean';

export function useAmountInputState(options) {
  const {
    errorMessage = 'amountError',
    validations,
    initialValue,
    isRequired = true,
    canBeZero = false,
    integerOnly = false,
    ...otherOptions
  } = options || {};

  return useInputState({
    initialValue: !isNil(initialValue) ? String(initialValue) : '',
    validations: [
      {
        validate: (value) => !isRequired || (value !== '' && !isNaN(Number(value))),
        errorMessage
      },
      {
        validate: (value) => (canBeZero ? Number(value) >= 0 : Number(value) > 0),
        errorMessage
      },
      {
        validate: (value) => (integerOnly ? parseInt(Number(value)) === Number(value) : !isNaN(Number(value))),
        errorMessage
      },
      {
        validate: (value) => vaildateMaxDigits(value),
        errorMessage: 'maxDigitError'
      },
      ...(validations || [])
    ],
    ...(otherOptions || {})
  });
}
